import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AuthService } from '../../../services';

@Component({
    selector: 'usc-store-nav',
    templateUrl: './usc-nav.component.html',
    styleUrls: ['./usc-nav.component.css']
})
export class UscNavComponent implements OnInit {

    campaigns: Array<any> = [
        { text: 'All', value: 'ALL' },
        { text: 'Account Growth', value: 'Account Growth' },
        { text: 'Add-A-Line', value: 'Add-A-Line' },
        { text: 'Referral', value: 'Referral' }
    ];

    store_unassigned_leads: number = 0;
    show_search_impression: boolean = false;
    current_campaign: string = "All";
    currentViewClass: any = {
        view_usc_home: "nav-item",
        view_usc_reports: "nav-item",
        view_usc_first_impression: "nav-item",
        view_usc_middle_impression: "nav-item",
        view_usc_lasting_impression: "nav-item",
        view_usc_plan_2_win: "nav-item",
        view_usc_book_of_business: "nav-item",
        view_usc_search_impression: "nav-item",
        view_usc_calendar: "nav-item",
        view_usc_retail_foundations: "nav-item",
        view_usc_store_visits: "nav-item",
        view_usc_uploaded_documents: "nav-item",
    }

    isLeader: boolean = false;
    isReportAllowed: boolean = false;
    isTelesales: boolean = false;
    isUSCellCorp: boolean = false;
    isP2WEnabled: boolean = false;
    is_p2w_ready: boolean = false;
    isRetailFoundationsEnabled: boolean = false;
    isStoreVisitsTabEnabled: boolean = false;

    constructor(
        public uscStoreService: UscStoreService,
        private authService: AuthService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.uscStoreService.p2wReady.subscribe(ready => {
            if (ready) this.is_p2w_ready = true;
        })

        this.uscStoreService.currentView.subscribe(
            (currentView) => {
                for (var p in this.currentViewClass) {
                    this.currentViewClass[p] = "nav-item";
                    if (p == currentView) {
                        this.currentViewClass[p] = "nav-item active";
                    }
                }
                if (currentView.indexOf('_p2w_') >= 0) {
                    this.currentViewClass.view_usc_plan_2_win = "nav-item active";
                } else if (currentView.indexOf('_svt_') >= 0) {
                    this.currentViewClass.view_usc_store_visits = "nav-item active";
                }
                this.show_search_impression = (currentView == this.uscStoreService.view_search);
            }
        );

        this.authService.currentUser.subscribe(
            user => {
                this.isLeader = this.uscStoreService.isLeader();
                this.isReportAllowed = this.uscStoreService.isReportAllowed();
                this.isTelesales = this.uscStoreService.isUSCellTelesales();
                this.isUSCellCorp = this.uscStoreService.isUSCellCorp();
                this.isP2WEnabled = this.uscStoreService.isP2WEnabled();
                this.isRetailFoundationsEnabled = this.uscStoreService.isRetailFoundationsEnabled();
                this.isStoreVisitsTabEnabled = this.uscStoreService.isStoreVisitTabEnabled() && this.uscStoreService.isQueuingModuleAccessEnabled();
            }
        )

        this.uscStoreService.calendarEvents.subscribe(events => {
            if (events) this.store_unassigned_leads = this.uscStoreService.getStoreUnassignedSameDayLeads();
        });
    }

    navigate(selection) {
        this.uscStoreService.setCurrentView(selection);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-nav/usc-nav.component.ts